import { apiClient } from './axiosInstance';
import { IPolicyInfoUpdatingData } from '../features/policyInfo/policyInfoTypes';

export const fetchPolicyInfo = async (policyId: number) => {
  return await apiClient.get(`/time-off/policies/${policyId}`);
};

export const updatePolicyInfo = async (data: IPolicyInfoUpdatingData) => {
  return await apiClient.patch(`/time-off/policies/${data.id}`, {
    ...data,
  });
};
